/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: aeeb275c (Fri Jul 31 21:53:12 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface FetchUserPlaylistsResponsePlaylists
 */
export interface FetchUserPlaylistsResponsePlaylists {
  /**
   * The unique identifier for the Playlist.
   * @type number
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  playlistKey: number
  /**
   * Display name of the playlist.
   * @type string
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  name: string
  /**
   * Defines the category of the playlist.'LearningCenter' or 'BusinessCenter' content.
   * @type string
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  playlistType: FetchUserPlaylistsResponsePlaylistsPlaylistTypeEnum
  /**
   * The actor key associated with this playlist, if any.
   * @type number
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  actorKey?: number | null
  /**
   * The date on which the playlist was created.
   * @type Date
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  createdDate?: Date
  /**
   * Total number of items contained in the playlist.
   * @type number
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  itemsCount?: number
  /**
   * Whether the playlist is shared with the user (true) or owned by the user (false).
   * @type boolean
   * @memberof FetchUserPlaylistsResponsePlaylists
   */
  isShared?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum FetchUserPlaylistsResponsePlaylistsPlaylistTypeEnum {
  LearningCenter = 'LearningCenter',
  BusinessCenter = 'BusinessCenter',
}

export function FetchUserPlaylistsResponsePlaylistsFromJSON(
  json: any
): FetchUserPlaylistsResponsePlaylists {
  return FetchUserPlaylistsResponsePlaylistsFromJSONTyped(json, false)
}

export function FetchUserPlaylistsResponsePlaylistsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchUserPlaylistsResponsePlaylists {
  if (json === undefined || json === null) {
    return json
  }
  return {
    playlistKey: json['playlistKey'],
    name: json['name'],
    playlistType: json['playlistType'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
    createdDate: !exists(json, 'createdDate')
      ? undefined
      : new Date(json['createdDate']),
    itemsCount: !exists(json, 'itemsCount') ? undefined : json['itemsCount'],
    isShared: !exists(json, 'isShared') ? undefined : json['isShared'],
  }
}

export function FetchUserPlaylistsResponsePlaylistsToJSON(
  value?: FetchUserPlaylistsResponsePlaylists | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    playlistKey: value.playlistKey,
    name: value.name,
    playlistType: value.playlistType,
    actorKey: value.actorKey,
    createdDate:
      value.createdDate === undefined
        ? undefined
        : value.createdDate.toISOString(),
    itemsCount: value.itemsCount,
    isShared: value.isShared,
  }
}
